<template>
  <div class="card-container">
    <div class="plus-icon-container">
      <div class="plus-icon-outer">
        <div class="plus-icon-inner">
          <i class="fas fa-plus"></i>
        </div>
      </div>
    </div>
    <div class="details">
      <div><b>AVAILABLE</b></div>
      <div>{{ timeSchedule }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';

export default {
  props: {
    endDate: [String, Date, Object],
    startDate: [String, Date, Object],
  },

  computed: {
    ...mapState({
      goTo: state => state.cards.goTo,
    }),

    timeSchedule() {
      const from = moment(this.startDate).format('h:mma');
      const to = moment(this.endDate).format('h:mma');
      return `${from}-${to}`;
    },
  },
};
</script>

<style lang="scss" scoped>
div.card-container {
  height: 100%;
  color: #ffffff;
  padding: 30px;
  box-sizing: border-box;
  border-radius: 24px;

  &::before {
    content: "";
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    background-color: #ffffff;
    z-index: -1;
    border-radius: 24px;
    opacity: 0.2;
  }
}

div.details {
  box-sizing: border-box;
  font-size: 1.5rem;
  display: flex;
  justify-content: space-between;

  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 30px;
  left: 0;
  display: flex;
}

div.plus-icon-container {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  &, div.plus-icon-outer {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  div.plus-icon-outer {
    box-sizing: border-box;
    height: 156px;
    width: 156px;
    border: 1px solid #979797;
    background-color: rgba(126,211,33,0.1);
    border: none;
    border-radius: 156px;

    div.plus-icon-inner {
      border: none;
      background: #7ED321;
      padding: 25px 28px;
      border-radius: 100px;

      i {
        font-size: 50px;
        color: #fff;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Booking/Card/NewBooking.vue